import {useTranslation} from "react-i18next";
import React, {useContext} from "react";
import OrderSettingsPageStoreContext from "../context";
import {observer} from "mobx-react";
import {FormControl, Paper, Typography} from "../../../../../common/components/libs";
import {Checkbox, FormControlLabel} from "@material-ui/core";
import {changeCheckboxEventHandlerDecorator} from "../../../../../common/libs";
import {useStores} from '../../../../../hooks';


const ChoosingLanguagesBlock = () => {
    const {t} = useTranslation(["general", "menu"]);
    const { authStore } = useStores()
    const store = useContext(OrderSettingsPageStoreContext);
    const languages = store.languages;


    if (!languages) return;

    const checking = ()=> {
            const newArray =[];
            if (languages) {
                for (let [key, value] of Object.entries(languages)) {
                    // @ts-ignore
                    if (value.isEnabled === true) {
                        newArray.push(key);
                    }
                }}
            return newArray;
    }

    const checkingArray = checking()


    const getLangSetter = (lang: string) => {
        return (value: string) => {
            if (!authStore.isSimpleFeaturesActive()) {
                store.openTariffPromptForm('Simple')
            } else {
                if (checkingArray.length>1) {
                    store.languages[lang].isEnabled = value;
                } else {
                    store.languages[lang].isEnabled = true;
                }
            }
        }
    }


    return(
        <div>
            <Typography variant={"h3"} mt={20} mb={2}>
                {t("menu:languages")}
            </Typography>
            <Paper p={5} style={{ maxWidth: 800, width: "100%" }}>
                <FormControl>
                    <FormControlLabel
                        value={languages.ru.isEnabled}
                        key="offline"
                        control={<Checkbox
                            checked={languages.ru.isEnabled}
                            onChange={changeCheckboxEventHandlerDecorator(getLangSetter("ru"))}
                        />}
                        label={
                        <Typography variant={'h6'}>
                            {t("menu:russian")}
                        </Typography>}
                        />
                </FormControl>
                <FormControl>
                    <FormControlLabel
                        value={languages.en.isEnabled}
                        key="offline"
                        control={<Checkbox
                            checked={languages.en.isEnabled && authStore.isSimpleFeaturesActive()}
                            onChange={changeCheckboxEventHandlerDecorator(getLangSetter("en"))}
                        />}
                        label={
                            <Typography variant={'h6'}>
                                {t("menu:english")}
                            </Typography>}
                    />
                </FormControl>
                <FormControl>
                    <FormControlLabel
                        value={languages.zh.isEnabled}
                        key="offline"
                        control={<Checkbox
                            checked={languages.zh.isEnabled && authStore.isSimpleFeaturesActive()}
                            onChange={changeCheckboxEventHandlerDecorator(getLangSetter("zh"))}
                        />}
                        label={
                            <Typography variant={'h6'}>
                                {t("menu:chinese")}
                            </Typography>}
                    />
                </FormControl>
                <FormControl>
                    <FormControlLabel
                        value={languages.it.isEnabled}
                        key="offline"
                        control={<Checkbox
                            checked={languages.it.isEnabled && authStore.isSimpleFeaturesActive()}
                            onChange={changeCheckboxEventHandlerDecorator(getLangSetter("it"))}
                        />}
                        label={
                            <Typography variant={'h6'}>
                                {t("menu:italian")}
                            </Typography>}
                    />
                </FormControl>
            </Paper>
        </div>
    )

}

export default observer(ChoosingLanguagesBlock)